import React from 'react';
import { Icon, OutlineButton, Typography } from 'glints-aries/es/@next';
import { Neutral } from 'glints-aries/es/@next/utilities/colors';
import { FormattedMessage } from 'react-intl';

import {
  ButtonGroup,
  CloseButton,
  Content,
  Description,
  Illustration,
  StyledModal,
} from './RoleSwitchModal.sc';

type RoleSwitchModalProps = {
  isOpen: boolean;
  isSwitching: boolean;
  onClose: () => void;
  onConfirm: () => void;
};

export default function RoleSwitchModal({
  isOpen,
  isSwitching,
  onClose,
  onConfirm,
}: RoleSwitchModalProps) {
  return (
    <StyledModal
      isOpen={isOpen}
      onClose={onClose}
      showCloseButton={false}
      closeOnClickOutside={!isSwitching}
      role="dialog"
      aria-modal="true"
      aria-label="Switch role to Job Seeker"
    >
      <Content>
        <CloseButton
          type="button"
          onClick={onClose}
          disabled={isSwitching}
          aria-label="Close"
        >
          <Icon name="ri-close" width={24} fill={Neutral.B40} />
        </CloseButton>
        <Illustration
          src="/images/role-switch-job-seeker.png"
          alt=""
          aria-hidden="true"
        />
        <Typography variant="subtitle1" as="h2">
          <FormattedMessage
            id="text-switch-role-to-jobseeker"
            defaultMessage={'Switch Role to “Job Seeker”'}
          />
        </Typography>
        <Description>
          <Typography variant="body1" color={Neutral.B40}>
            <FormattedMessage
              id="text-your-current-role-is-employer"
              defaultMessage={
                'Your current role is “Employer”, do you want to switch to “Job Seeker”?'
              }
            />
          </Typography>
        </Description>
        <ButtonGroup fullWidth={true}>
          <OutlineButton
            size="large"
            disabled={isSwitching}
            onClick={onClose}
            data-glints-tracking-element-name="go_back_to_employer"
          >
            <Typography variant="button" as="span">
              <FormattedMessage
                id="interactive-role-switch-go-back-to-emp"
                defaultMessage="No, I am hiring"
              />
            </Typography>
          </OutlineButton>
          <OutlineButton
            size="large"
            loading={isSwitching}
            disabled={isSwitching}
            onClick={onConfirm}
            data-glints-tracking-element-name="switch_to_jobseeker"
          >
            <Typography variant="button" as="span">
              <FormattedMessage
                id="interactive-switch-to-jobseeker"
                defaultMessage={'Switch to “Job Seeker”'}
              />
            </Typography>
          </OutlineButton>
        </ButtonGroup>
      </Content>
    </StyledModal>
  );
}
